<template>
  <div class="stats-indicator">
    <slot name="header">
      <h6>Statystyki</h6>
    </slot>
    <div class="indicator-text">
      <div class="circle-icon">
        <i :class="icon"></i>
      </div>
      <div class="stats-value">
        <span>{{ stats }}</span> {{ unit }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['stats', 'unit', 'icon'],
  methods: { }
}
</script>
<style lang="scss">
@import 'src/stylesheets/variables';

.stats-indicator {
  padding: 2.7rem 0;
  width: 100%;
  height: 100%;
  text-align: center;

  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;

  h6 {
    color: $default-text-color;
    margin: 0;

    @media #{$small-and-down} {
      font-size: 1.2rem;
    }
  }

  p {
    margin: 0;
  }

  .indicator-text {
    display: flex;
    margin: 0 auto;
    min-width: 140px
  }

  .circle-icon {
    background-color: $primary-color;
    color: $button-new-ui-default-color;
    font-size: 1.1rem;
    font-weight: 700;
    text-align: center;
    border-radius: 50%;
    box-shadow: 0 0 40px -6px rgba(0, 0, 0, 0.5);
    line-height: 2.55em;
    width: 2.4em;
    height: 2.4em;
    float: left;
    margin-right: 20px;
  }

  .stats-value {
    color: $primary-color;
    font-family: 'latoblack';
    font-size: 2.5rem;
    line-height: 2.5rem;
  }
}
</style>



// WEBPACK FOOTER //
// statsIndicator.vue?f063e252